import { reducer } from "ts-action";
import _omit from "lodash/omit";
import _pickBy from "lodash/pickBy";
import _omitBy from "lodash/omitBy";

import { on } from "ts-action-immer";
import * as AC from "../actionCreators";
import { Dictionary, UserFilter, UserFilterId } from "../../../globalTypes";
import { TableKind } from "../../tableData/types";
import { matchFilterAgainstIdentifier } from "../../../utils/userFilters";

type State = Dictionary<UserFilterId, UserFilter>;

const initialState: State = {};

const makeByIdReducerForTableKind = (kind: TableKind) =>
  reducer(
    initialState,
    /* GETs */
    on(AC.userFilterGetAllFiltersSuccess, (state, { payload }) =>
      _pickBy(
        payload.filters,
        (filter) => filter?.tableIdentifier.kind === kind
      )
    ),
    on(AC.userFilterGetFilterByIdSuccess, (state, { payload }) => {
      const { filterId, filter } = payload;
      if (filter.tableIdentifier.kind === kind) {
        state[filterId] = filter;
      }
    }),
    on(AC.userFilterGetFiltersForTableSuccess, (state, { payload }) => {
      const { filters, identifier } = payload;
      if (identifier.kind !== kind) return state;

      const filtersForOtherIds = _omitBy(
        state, // I <3 PRETTIER
        (filter) => matchFilterAgainstIdentifier(filter, identifier)
      );

      return { ...filtersForOtherIds, ...filters };
    }),

    /* EDIT */
    on(AC.userFilterPutFilterRequest, (state, { payload }) => {
      const { filter, filterId } = payload;
      if (filter.tableIdentifier.kind === kind) {
        state[filterId] = filter;
      }
    }),
    on(AC.userFilterPutFilterError, (state, { payload }) => {
      const { oldFilter, filterId } = payload;
      if (oldFilter?.tableIdentifier.kind === kind) {
        if (!filterId || !oldFilter) return;
        state[filterId] = oldFilter;
      }
    }),
    /* POST */
    on(AC.userFilterPostNewFilterSuccess, (state, { payload }) => {
      const { filter } = payload;
      if (filter.tableIdentifier.kind === kind) {
        state[filter.id] = filter;
      }
    }),
    /* DELETE */
    on(AC.userFilterDeleteFilterRequest, (state, { payload }) => {
      const { filterId } = payload;
      return _omit(state, [filterId]);
    }),
    on(AC.userFilterDeleteFilterError, (state, { payload }) => {
      const { filterId, oldFilter } = payload;
      if (oldFilter?.tableIdentifier.kind === kind) {
        if (!filterId || !oldFilter) return;
        state[filterId] = oldFilter;
      }
    })
  );

export default makeByIdReducerForTableKind;
export type FiltersById = State;
